import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class SandboxGuard {
  constructor() {}

  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
  ): boolean {
    if (environment && environment.production === false) {
      return true;
    }
    return false;
  }
}
